import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Row, Col, Input, Form, Label, FormGroup, Card, CardBody } from 'reactstrap';
import CustomToast from '../../utils/CustomToast';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const Terms = ({ draftStatus, onSubmit, onData, data, onPrevPage, onDraftSubmit, award, submitFormStatus, current_user_id, current_user_token }) => {
    const { register, setValue, getValues, handleSubmit, watch } = useForm({
        defaultValues: {
            terms_of_service: '',
            privacy_policy: '',
            case_study_showcase: 'No'
        },
    });
    
    const [discounted, setDiscounted] = useState(false);
    const [free, setFree] = useState(false);
    const [couponLoading, setCouponLoading] = useState(false);
    const [couponInput, setCouponInput] = useState('');
    const [couponPayload, setCouponPayload] = useState('');
    const [entrantEntrySubmissionCount, setEntrantEntrySubmissionCount] = useState(0);
    const [entryFee,setEntryFee] = useState(145);
    const [paid, setPaid] = useState(data.paid || 0);

    // const paidAwards = [47, 7, 67, 125];
    const paidAwards = [47, 7, 67, 125, 166];
    // const awardEntryDiscountPrice = {
    //     7: 35,
    //     47: 35,
    //     67: 45,
    //     125: 45,
    // };

    const awardEntryDiscountPrice = {
        7: 35,
        47: 35,
        67: 45,
        125: 45,
        166: 45,
    };

    const location = useLocation();
    var currentPathName = location.pathname;

    const postCouponCode = async data => {
        return await axios.post(
            process.env.REACT_APP_API_ENDPOINT + 'sponsorship/coupon/validator',
            data,
        );
    };

    const getEntrantEntrySubmissionCount = async () => {
        return await axios.get(
            process.env.REACT_APP_API_ENDPOINT + `award/${award.id}/check-entrant-entry-submission-count`,
            {
                params: {
                    user_id: current_user_id,
                    token: current_user_token,
                },
            },
        );
    };
    // console.log("data", data);
    const togglePrevPage = () => {
        onPrevPage();
        onData({ terms: getValues() });
    }

    const saveDraftSubmit = () => {
        onDraftSubmit(getValues());
    };

    const submit = (e) => {
        const terms = getValues('terms_of_service');
        const privacy = getValues('privacy_policy');
        
        if (!terms || !privacy) {
            CustomToast.error('Please agree to our Terms and Conditions and Privacy Policy to continue!');
            return;
        }
    
        onData({ terms: e });
        onSubmit(e);
    };    

    const handleKeyDown = e => {
        if (e.keyCode === 13) {
        e.preventDefault();
        }
    };
    const handleChangeCoupon = e => {
        const { value } = e.target;
        setCouponInput(() => value);
    };

      const applyCoupon = async e => {
        if (couponLoading) return;
    
        e.preventDefault();
        setCouponPayload(couponInput);
        setCouponLoading(true);
    
        const payload = {
          award_id: award.id,
          coupon_code: couponInput,
        //   company_name: formData.organization_name,
        };
    
        await postCouponCode(payload)
          .then(response => {
            const status = response.data.status;
            if (status === 'Success') {
              const promo = response.data.promo;
              setFree(promo == 'Free');
              setDiscounted(promo == 'Discounted');
              const message = 'Coupon Code applied successfully!';
              CustomToast.success(message);
              setValue('free', promo == 'Free');
              setValue('discounted', promo == 'Discounted');
            } else {
              setFree(false);
              setDiscounted(false);
              const message = 'Invalid Coupon Code!';
              CustomToast.warning(message);
            }
            setCouponLoading(false);
          })
          .catch(() => {
            CustomToast.defaultError();
          });
      };

    useEffect(() => {
        if (paidAwards.includes(Number(award.id))) {
            getEntrantEntrySubmissionCount().then(response => {
                const data = response.data.data;
                // console.log("Data", data);
                if (response.data.status == "Success") {
                    setEntrantEntrySubmissionCount(data.entry_count);
                    if(data.entry_count < 1) {
                        setEntryFee(145);
                    } else {
                        setEntryFee(45);
                    }
                } else {
                    CustomToast.defaultWarning();
                    setEntryFee(145);
                }
            }).catch((error) => {
                CustomToast.defaultError();
                console.log("Error", error);
                setEntryFee(145);
            });
        }
    }, [])

    useEffect(() => {
        if (data) {
            setValue('terms_of_service', data.terms_of_service === 'Agreed' ? 'Agreed' : '');
            setValue('privacy_policy', data.privacy_policy === 'Agreed' ? 'Agreed' : '');
            setValue('case_study_showcase', data.case_study_showcase === 'Yes' ? 'Yes' : 'No');
            setValue('coupon_code', data.coupon_code);
            setFree(data.free || false);
            setDiscounted(data.discounted || false);

        }
    }, [data, setValue]);    

    useEffect(() => {
        if (paidAwards.includes(Number(award.id))) {
            setValue('free', free);
            setValue('discounted', discounted);
            // setValue('subtotal_amount', free ? 0 : discounted ? awardEntryDiscountPrice[Number(award.id)] : 95)
            setValue('subtotal_amount', free ? 0 : discounted ? awardEntryDiscountPrice[Number(award.id)] : entryFee)
            
        }
    }, [free, discounted, entryFee])

    return (
        <Col lg="12" className="px-0">
            <Form onSubmit={handleSubmit(submit)}>
                <Row>
                    <Card className="w-100 mx-3 mb-3">
                        <CardBody>
                            <Col lg="12" className="p-0">
                                <FormGroup check className="mb-1">
                                    <Label
                                        for="terms_of_service"
                                        className="award-subheader font-weight-bold mb-2"
                                    >
                                        TERM OF SERVICE
                                        <span className="asterisk_red">*</span>
                                    </Label>
                                    <br />
                                    <Label check className="checkbox-form">
                                        <Input
                                            type="checkbox"
                                            checked={watch('terms_of_service') === 'Agreed'}
                                            {...register('terms_of_service', {
                                                setValueAs: v => (v ? 'Agreed' : ''),
                                                onChange: (e) => {
                                                    setValue('terms_of_service', e.target.checked ? 'Agreed' : '');
                                                },
                                            })}
                                        />
                                        <p className="form-p">
                                            I agree to the Entry{' '}
                                            <a
                                                href={award.event.terms_conditions_url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{
                                                    color: '#1EC2F3',
                                                    textDecoration: 'underline',
                                                }}
                                            >
                                                Terms & Conditions
                                            </a>.
                                        </p>
                                    </Label>
                                </FormGroup>
                            </Col>
                            <Col lg="12" className="p-0">
                                <FormGroup check className="mb-1">
                                    <Label
                                        for="privacy_policy"
                                        className="award-subheader font-weight-bold mb-2"
                                    >
                                        PRIVACY POLICY
                                        <span className="asterisk_red">*</span>
                                    </Label>    
                                    <br />
                                    <Label check className="checkbox-form">
                                        <Input
                                            type="checkbox"
                                            checked={watch('privacy_policy') === 'Agreed'}
                                            {...register('privacy_policy', {
                                                setValueAs: v => (v ? 'Agreed' : ''),
                                                onChange: (e) => {
                                                    setValue('privacy_policy', e.target.checked ? 'Agreed' : '');
                                                },
                                            })}
                                        />
                                        <p className="form-p">
                                            I agree to the Entry Awards'{' '}
                                            <a
                                                href={award.event.privacy_policy_url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{
                                                    color: '#1EC2F3',
                                                    textDecoration: 'underline',
                                                }}
                                            >
                                                Privacy Policy
                                            </a>.
                                        </p>
                                    </Label>
                                </FormGroup>
                                <FormGroup check className="mb-3">
                                    <Label
                                        for="case_study_showcase"
                                        className="award-subheader font-weight-bold mb-2"
                                    >
                                        If your entry wins, would you like your submission document to be showcased publicly as a case study?
                                    </Label>

                                    <div>
                                        <Label check className="checkbox-form">
                                        <Input
                                            type="radio"
                                            value="Yes"
                                            {...register('case_study_showcase', {
                                            setValueAs: v => v, // just keep the string
                                            onChange: (e) => {
                                                setValue('case_study_showcase', e.target.value);
                                            },
                                            })}
                                            checked={watch('case_study_showcase') === 'Yes'}
                                        />
                                        <span className="form-p">Yes</span>
                                        </Label>
                                        <br />
                                        <Label check className="checkbox-form mt-1">
                                        <Input
                                            type="radio"
                                            value="No"
                                            {...register('case_study_showcase', {
                                            setValueAs: v => v,
                                            onChange: (e) => {
                                                setValue('case_study_showcase', e.target.value);
                                            },
                                            })}
                                            checked={watch('case_study_showcase') === 'No'}
                                        />
                                        <span className="form-p">No</span>
                                        </Label>
                                    </div>
                                </FormGroup>
                                {paidAwards.includes(Number(award.id)) && !paid ? (
                                    <>
                                        <FormGroup>
                                        <Label
                                            for="trophyPosition"
                                            className="award-subheader font-weight-bold"
                                        >
                                            COUPON CODE
                                        </Label>
                                        <div className="d-flex flex-row align-items-center">
                                            {/* <Input
                                            onKeyDown={handleKeyDown}
                                            type="text"
                                            name="coupon_code"
                                            onChange={handleChangeCoupon}
                                            value={couponInput}
                                            disabled={free}
                                            /> */}
                                            <Input
                                                onKeyDown={handleKeyDown}
                                                disabled={free}
                                                type="text"
                                                value={watch('coupon_code')}
                                                {...register('coupon_code', {
                                                    onChange: (e) => {
                                                        setValue('coupon_code', e.target.value);
                                                        handleChangeCoupon(e);
                                                    },
                                                })}
                                            />
                                            {!free ?
                                                <button
                                                    className="newbuttontheme ml-2"
                                                    onClick={e => applyCoupon(e)}
                                                >
                                                {!couponLoading
                                                    ? 'APPLY'
                                                    : 'APPLYING...'}
                                                </button>
                                                :
                                                <button
                                                    className="newbuttontheme ml-2"
                                                    onClick={e => applyCoupon(e)}
                                                    disabled
                                                    >APPLY
                                                    </button>
                                                }
                                        </div>
                                        </FormGroup>
                                        <Card className="total-price mt-4 mb-3">
                                        <CardBody>
                                            <Row>
                                            <Col lg="12">
                                                <Label className="font-weight-bold">
                                                PAYMENT SUMMARY
                                                </Label>
                                            </Col>
                                            <Col lg="9">
                                                <p className="text-left font-weight-normal">
                                                Subtotal:
                                                </p>
                                            </Col>
                                            <Col lg="3">
                                                <p className="font-weight-bold text-right mb-1">
                                                {free ? (
                                                    '€00.00'
                                                ) : (
                                                    <>
                                                    €
                                                    {discounted
                                                        ? awardEntryDiscountPrice[
                                                        award.id
                                                        ]
                                                        // : 95 + '.00'}
                                                         : entryFee + '.00'}
                                                        
                                                    </>
                                                )}
                                                </p>
                                            </Col>
                                            <Col lg="9">
                                                <p className="text-left font-weight-normal">
                                                VAT:
                                                </p>
                                            </Col>
                                            <Col lg="3">
                                                <p className="font-weight-bold text-right mb-1">
                                                {free ? (
                                                    '€00.00'
                                                ) : (
                                                    <>
                                                    €
                                                    {discounted
                                                        ? awardEntryDiscountPrice[
                                                        award.id
                                                        ] * 0.23
                                                        // : 95 * 0.23}
                                                        : entryFee * 0.23}
                                                    </>
                                                )}
                                                </p>
                                            </Col>
                                            <Col lg="9">
                                                <p className="text-left font-weight-normal">
                                                Total:
                                                </p>
                                            </Col>
                                            <Col lg="3">
                                                <p className="font-weight-bold text-right">
                                                {free ? (
                                                    '€00.00'
                                                ) : (
                                                    <>
                                                    €
                                                    {discounted
                                                        ? awardEntryDiscountPrice[
                                                        award.id
                                                        ] +
                                                        awardEntryDiscountPrice[
                                                        award.id
                                                        ] *
                                                        0.23
                                                        // : 95 + 95 * 0.23}
                                                        : entryFee + entryFee * 0.23}
                                                    </>
                                                )}
                                                </p>
                                            </Col>
                                            </Row>
                                            <Row className="mt-3">
                                            <Col lg="12">
                                                <Label className="font-weight-bold">
                                                NOTES
                                                </Label>
                                            </Col>
                                            <Col
                                                lg="12"
                                                className="mb-0 d-flex align-items-center"
                                            >
                                                <p className="text-left font-weight-normal">
                                                Thank you for your order.
                                                </p>
                                            </Col>
                                            </Row>
                                            <Row className="mt-3">
                                            <Col lg="12">
                                                <Label className="font-weight-bold">
                                                TERMS
                                                </Label>
                                            </Col>
                                            <Col lg="4" className="mb-0">
                                                <p className="text-left font-weight-normal">
                                                Company Information:
                                                </p>
                                            </Col>
                                            <Col lg="8" className="mb-0">
                                                <p className="text-right font-weight-bold mb-1">
                                                Event Strategies Ltd.
                                                <br />
                                                Suite 10716, 5 Fitzwilliam
                                                Square
                                                <br />
                                                Dublin 2, D02 R744
                                                <br />
                                                </p>
                                            </Col>
                                            <Col lg="4" className="mb-0">
                                                <p className="text-left font-weight-normal">
                                                VAT Number:
                                                </p>
                                            </Col>
                                            <Col lg="8" className="mb-0">
                                                <p className="text-right font-weight-bold mb-1">
                                                IE9667343H
                                                </p>
                                            </Col>
                                            <Col lg="4" className="mb-0">
                                                <p className="text-left font-weight-normal">
                                                VAT Rate Value:
                                                </p>
                                            </Col>
                                            <Col lg="8" className="mb-0">
                                                <p className="text-right font-weight-bold">
                                                23%
                                                </p>
                                            </Col>
                                            </Row>
                                        </CardBody>
                                        </Card>
                                        <div className="alert alert-info">
                                        <p className="mb-0">
                                            The entry will only be confirmed once
                                            the payment has been completed
                                            successfully.
                                        </p>
                                        </div>
                                    </>
                                    ) : null}
                            </Col>
                        </CardBody>
                    </Card>
                </Row>
                <Row>

                    <Col md="4" className="text-left">
                        <button
                            className="btn btn-outline-dark-prev"
                            onClick={togglePrevPage}
                            style={{ width: '130px', fontSize: '14px' }}
                            type='button'
                        >
                            <strong>PREVIOUS</strong>
                        </button>
                    </Col>
                    <Col md="8" className="text-right">
                        {currentPathName == "/entry-form/preview" ?
                            <>
                                {/* <div className="bis-tooltip p-0" style={{ border: 'none', background: 'transparent' }}>
                                    <button
                                        className="btn btn-transparent text-dark"
                                        style={{ width: '180px', fontSize: '14px' }}
                                        type='button'
                                        disabled
                                    >
                                        <strong>SAVE FOR LATER</strong>
                                        <span className="bis-tooltiptext" style={{ width: '220px', marginLeft: '-107px' }}>This action is unavailable in this preview version</span>
                                    </button>
                                </div> */}
                                <div className="bis-tooltip p-0" style={{ border: 'none', background: 'transparent' }}>
                                    <button
                                        className="btn btn-blue-new"
                                        type="button"
                                        disabled
                                        style={{ width: '130px', fontSize: '14px' }}
                                    >
                                        <strong>SUBMIT</strong>
                                        <span className="bis-tooltiptext" style={{ width: '220px', marginLeft: '-107px' }}>This action is unavailable in this preview version</span>
                                    </button>
                                </div>
                            </>
                        :
                            <>
                                {data.status == '' || data.status == 'Draft' ? (
                                    <button
                                        className="btn btn-transparent text-dark"
                                        // onClick={saveDraftSubmit}
                                        onClick={!draftStatus ? saveDraftSubmit : undefined}
                                        style={{ width: '180px', fontSize: '14px' }}
                                        type='button'
                                        disabled={draftStatus}
                                    >
                                        <strong>{!draftStatus ? 'SAVE FOR LATER' : 'SAVING...'}</strong>
                                    </button>
                                ) : null}
                                {paidAwards.includes(Number(award.id)) && !paid ? (
                                    <button
                                        className="btn btn-blue-new"
                                        type="submit"
                                        style={{ width: '130px', fontSize: '14px' }}
                                        disabled={submitFormStatus}
                                    >
                                        <strong>CHECKOUT</strong>
                                    </button>
                                ) : (
                                    <button
                                        className="btn btn-blue-new"
                                        type="submit"
                                        style={{ width: '130px', fontSize: '14px' }}
                                        disabled={submitFormStatus}
                                    >
                                        <strong>SUBMIT</strong>
                                    </button>
                                )}
                            </>
                        }
                    </Col>
                </Row>
            </Form>
        </Col >
    );
};

export default Terms;